const getEnvironmentVariables = () => {
    if (window.location.host.includes('localhost') || window.location.host.includes("127.0.0.1")) {
        return {
            REACT_APP_CENTRAL_AUTH: "http://localhost:6001",
            REACT_APP_REST_API: "http://localhost:9002",
            REACT_APP_ENVIRONMENT: "local",
            REACT_APP_KEYCLOAK_URL: "https://sso-staging.ocelotlinks.com",
            REACT_APP_KEYCLOAK_REALM: "OcelotLinks",
            REACT_APP_KEYCLOAK_CLIENTID: "myclient",
            QR_CODE_URL: "https://etims-sbx.kra.go.ke/common/link/etims/receipt/indexEtimsInvoiceData?Data=",
            REACT_APP_FARO_URL: "",
            REACT_APP_FARO_APP_NAME: "customer-portal",
            REACT_APP_FARO_SAMPLE_RATE: "1",
        };
    } else if (window.location.host.includes('marketplace-staging.ocelotlinks.com')) {
        return {
            REACT_APP_CENTRAL_AUTH: "https://central-auth-staging.ocelotlinks.com",
            REACT_APP_REST_API: "https://api-staging.ocelotlinks.com",
            REACT_APP_ENVIRONMENT: "staging",
            REACT_APP_KEYCLOAK_URL: "https://sso-staging.ocelotlinks.com",
            REACT_APP_KEYCLOAK_REALM: "OcelotLinks",
            REACT_APP_KEYCLOAK_CLIENTID: "myclient",
            QR_CODE_URL: "https://etims-sbx.kra.go.ke/common/link/etims/receipt/indexEtimsInvoiceData?Data=",
            REACT_APP_FARO_URL: "https://faro.ocelotlinks.com/collect",
            REACT_APP_FARO_APP_NAME: "customer-portal",
            REACT_APP_FARO_SAMPLE_RATE: "1",
        };
    } else if (window.location.host.includes('marketplace.ocelotlinks.com')) {
        return {
            REACT_APP_CENTRAL_AUTH: "https://central-auth.ocelotlinks.com",
            REACT_APP_REST_API: "https://api.ocelotlinks.com",
            REACT_APP_ENVIRONMENT: "production",
            REACT_APP_KEYCLOAK_URL: "https://sso.ocelotlinks.com",
            REACT_APP_KEYCLOAK_REALM: "OcelotLinks",
            REACT_APP_KEYCLOAK_CLIENTID: "myclient",
            QR_CODE_URL: "https://etims.kra.go.ke/common/link/etims/receipt/indexEtimsInvoiceData?Data=",
            REACT_APP_FARO_URL: "https://faro.ocelotlinks.com/collect",
            REACT_APP_FARO_APP_NAME: "customer-portal",
            REACT_APP_FARO_SAMPLE_RATE: "0.3",
        };
    } else {
        throw new Error("Unsupported hostname");
    }

};


export const ENV = getEnvironmentVariables();
